import { render, staticRenderFns } from "./ConfirmacaoModal.vue?vue&type=template&id=64c9a8dd"
import script from "./ConfirmacaoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoModal.vue?vue&type=style&index=0&id=64c9a8dd&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c9a8dd')) {
      api.createRecord('64c9a8dd', component.options)
    } else {
      api.reload('64c9a8dd', component.options)
    }
    module.hot.accept("./ConfirmacaoModal.vue?vue&type=template&id=64c9a8dd", function () {
      api.rerender('64c9a8dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modals/ConfirmacaoModal.vue"
export default component.exports